import { ActionReducerMap, MetaReducer } from '@ngrx/store';
import FacilityState, * as fromData from '../brain-data/store/reducers/facility.reducer';
import UtilityState, * as fromUtility from '../brain-data/store/reducers/utility.reducer';
import AuthenticationState, * as fromAuthentication from '../brain-data/store/reducers/authentication.reducer';
import UtilityContractState, * as fromUtilityContract from '../brain-data/store/reducers/utility-contract.reducer';
import UtilityBillsState, * as fromUtilityBills from '../brain-data/store/reducers/utility-bills.reducer';
import ConfigState, * as fromConfig from '../brain-data/store/reducers/config.reducer';

import LiveFeedState, * as fromExternalProvider from '../brain-data/store/reducers/external-provider.reducer';
import AlertState, * as fromAlert from '../brain-data/store/reducers/alert.reducer';
import SubSystemState, * as fromSubSystem from '../brain-data/store/reducers/sub-system.reducer';
import EmissionsState, * as fromEmissions from '../brain-data/store/reducers/emissions.reducer';
import ReportState, * as fromReport from 'brain-data/store/reducers/report.reducer';
import UserState, * as fromUser from 'brain-data/store/reducers/user.reducer';
import AccessLogState, * as fromAccessLog from 'brain-data/store/reducers/access-log.reducer';
import RoleState, * as fromRole from 'brain-data/store/reducers/role.reducer';
import ChargepointState, * as fromChargepoint from '../brain-data/store/reducers/chargepoint.reducer';
import UIState, * as fromUI from 'brain-portal/store/ui.reducer';
import { environment } from '../../environments/environment';
import EnergyStarItemState, * as fromEnergyStar from 'brain-data/store/reducers/energy-star-item.reducer';
import EnergyStarAccountState, * as fromEnergyStarAccount from 'brain-data/store/reducers/energy-star-account.reducer';
import { ProviderState, providerReducer } from '../../../brain-data/store/reducers/provider.reducer';
import { LeaseState, leaseReducer } from '../../../brain-data/store/reducers/lease.reducer';
import SystemIntegrationState, * as fromSystemIntegration from 'brain-data/store/reducers/system-integration.reducer';
import ResponsibleOfficialState, * as fromResponsibleOfficial from 'brain-data/store/reducers/responsible-official.reducer';
import TariffState, * as fromTariff from 'brain-data/store/reducers/tariff.reducer';
import ContractRawValuesState, * as fromContractRawValues from 'brain-data/store/reducers/contract-raw-values.reducer';
import EstreamPanelState, * as fromEstreamPanel from 'brain-data/store/reducers/estream-panel.reducer';
import EstreamComputeState, * as fromEstreamCompute from 'brain-data/store/reducers/estream-compute.reducer';
import EstreamComputeRangeState, * as fromEstreamComputeRange from 'brain-data/store/reducers/estream-compute-range.reducer';
import EstreamContractStatusState, * as fromEstreamContractStatus from 'brain-data/store/reducers/estream-contract-status.reducer';
import UtilityRateState, * as fromUtilityRate from 'brain-data/store/reducers/utility-rate.reducer';
import CustomFieldDefinitionState, * as fromCustomFieldDefinition from 'brain-data/store/reducers/custom-field-definition.reducer';
import TutorialVideoState, * as fromTutorialVideo from 'brain-data/store/reducers/tutorial-video.reducer';

export interface State {
  alert: AlertState;
  config: ConfigState;
  facility: FacilityState;
  utility: UtilityState;
  utilityContract: UtilityContractState;
  utilityBills: UtilityBillsState;
  authentication: AuthenticationState;
  externalProvider: LiveFeedState;
  subSystem: SubSystemState;
  emissions: EmissionsState;
  report: ReportState;
  user: UserState;
  accessLog: AccessLogState;
  role: RoleState;
  ui: UIState;
  chargepoint: ChargepointState;
  energyStarItem: EnergyStarItemState;
  energyStarAccount: EnergyStarAccountState;
  provider: ProviderState;
  lease: LeaseState;
  systemIntegration: SystemIntegrationState;
  responsibleOfficial: ResponsibleOfficialState;
  tariff: TariffState;
  contractRawValues: ContractRawValuesState;
  estreamPanel: EstreamPanelState;
  estreamCompute: EstreamComputeState;
  estreamComputeRange: EstreamComputeRangeState;
  estreamContractStatus: EstreamContractStatusState;
  utilityRate: UtilityRateState;
  customFieldDefinition: CustomFieldDefinitionState;
  tutorialVideo: TutorialVideoState;
}

export const reducers: ActionReducerMap<State> = {
  alert: fromAlert.reducer,
  config: fromConfig.reducer,
  facility: fromData.reducer,
  utility: fromUtility.reducer,
  utilityContract: fromUtilityContract.reducer,
  utilityBills: fromUtilityBills.reducer,
  authentication: fromAuthentication.reducer,
  externalProvider: fromExternalProvider.reducer,
  subSystem: fromSubSystem.reducer,
  emissions: fromEmissions.reducer,
  report: fromReport.reducer,
  user: fromUser.reducer,
  accessLog: fromAccessLog.reducer,
  role: fromRole.reducer,
  ui: fromUI.reducer,
  chargepoint: fromChargepoint.chargepointReducer,
  energyStarItem: fromEnergyStar.energyStarItemReducer,
  energyStarAccount: fromEnergyStarAccount.reducer,
  provider: providerReducer,
  lease: leaseReducer,
  systemIntegration: fromSystemIntegration.systemIntegrationReducer,
  responsibleOfficial: fromResponsibleOfficial.reducer,
  tariff: fromTariff.reducer,
  contractRawValues: fromContractRawValues.reducer,
  estreamPanel: fromEstreamPanel.reducer,
  estreamCompute: fromEstreamCompute.reducer,
  estreamComputeRange: fromEstreamComputeRange.reducer,
  estreamContractStatus: fromEstreamContractStatus.reducer,
  utilityRate: fromUtilityRate.reducer,
  customFieldDefinition: fromCustomFieldDefinition.reducer,
  tutorialVideo: fromTutorialVideo.reducer,
};

export const metaReducers: MetaReducer<State>[] = !environment.production ? [] : [];
